exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0;background-color:#666;font-family:Nunito SemiBold}#div_wrap{max-width:768px;background-color:#fff;border-radius:5px;margin-left:auto;margin-right:auto;padding:50px}#div_wrap:after{content:\" \";display:block;clear:both}#div_left{float:left;width:24%;text-align:right;margin:5px 15px 0 0}#div_right{float:right;width:74%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57d4882e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 105
// module chunks = 0